import api from './config';

// Get all industries
export const getIndustries = async () => {
  try {
    const response = await api.get('/common/industries');
    return response.data;
  } catch (error) {
    console.error('Error fetching industries:', error);
    throw error;
  }
};

// Get all districts
export const getDistricts = async () => {
  try {
    const response = await api.get('/common/districts');
    return response.data;
  } catch (error) {
    console.error('Error fetching districts:', error);
    throw error;
  }
};
